// 在職 / 離職證明 (電子) — letterhead + 列印 / 存 PDF (print CSS 隔離)。
// 資料來自 employee_profile (到職/離職日) + 職稱。員工辦貸款/簽證/租屋常要。
import { DownloadPdfButton } from './DownloadPdfButton.tsx';
const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()} 年 ${d.getMonth() + 1} 月 ${d.getDate()} 日`;
};

export function EmploymentCertificateDocument({
  name,
  title,
  department,
  hireDate,
  terminationDate,
}: {
  name: string;
  title: string | null;
  department: string | null;
  hireDate: string | null;
  terminationDate: string | null;
}) {
  const isTerminated = !!terminationDate;
  const role = [department, title].filter(Boolean).join(' · ') || '員工';
  return (
    <div>
      <style>{`.ec-doc { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      @media print {
        body * { visibility: hidden !important; }
        .ec-doc, .ec-doc * { visibility: visible !important; }
        .ec-doc { position: absolute; left: 0; top: 0; width: 100%; padding: 0 !important; border: none !important; box-shadow: none !important; }
        .no-print { display: none !important; }
      }`}</style>

      <div className="flex justify-end gap-2 mb-3 no-print">
        <DownloadPdfButton
          targetSelector=".ec-doc"
          fileName={`${isTerminated ? '離職' : '在職'}證明_${name}`}
        />
      </div>

      <div className="ec-doc bg-white border border-slate-200 rounded-lg p-8 max-w-2xl mx-auto text-slate-800">
        <div className="flex items-center gap-3 border-b-2 border-slate-800 pb-3 mb-6">
          <img
            src="/tristone-on-light.svg"
            alt="叁石資本"
            className="w-12 h-12 shrink-0"
            draggable={false}
          />
          <div className="flex-1 min-w-0">
            <div className="text-base font-bold tracking-wide leading-tight">
              叁石資本管理顧問股份有限公司
            </div>
            <div className="text-xs text-slate-500 mt-0.5">Tristone Capital</div>
          </div>
        </div>

        <h2 className="text-center text-xl font-bold tracking-[0.3em] mb-8">
          {isTerminated ? '離 職 證 明' : '在 職 證 明'}
        </h2>

        <div className="text-[15px] leading-loose space-y-4">
          {isTerminated ? (
            <p>
              茲證明 <strong className="px-1">{name}</strong> 君 曾於 本公司 擔任{' '}
              <strong className="px-1">{role}</strong> 職務，任職期間自{' '}
              <strong>{hireDate ?? '—'}</strong> 起 至 <strong>{terminationDate}</strong> 止，
              現已離職，特此證明。
            </p>
          ) : (
            <p>
              茲證明 <strong className="px-1">{name}</strong> 君 現任職於 本公司，擔任{' '}
              <strong className="px-1">{role}</strong> 職務，到職日為{' '}
              <strong>{hireDate ?? '—'}</strong>，目前仍在職，特此證明。
            </p>
          )}
        </div>

        <div className="mt-16 text-right text-[15px] leading-loose">
          <div>叁石資本管理顧問股份有限公司</div>
          <div className="text-slate-400 text-sm mt-1">（用印處）</div>
          <div className="mt-6">中華民國 {todayStr()}</div>
        </div>

        <p className="mt-8 text-[11px] text-slate-400 border-t border-slate-100 pt-3">
          本證明由系統依人事資料產出，須加蓋公司印信後方為正式文件。
        </p>
      </div>
    </div>
  );
}
